module.exports = __webpack_public_path__ + "img/link_chain_off.02032f6e.svg";